import { Location, NavigateFunction, NavigateOptions } from "react-router-dom";

const returnLocationSessionStorageKey = 'countbubble:return-location';

const getSessionStorage = () => {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
};

export const getCurrentLocationPath = (location: Pick<Location, 'pathname' | 'search' | 'hash'>) => {
    return `${location.pathname}${location.search || ''}${location.hash || ''}`;
};

export const getReturnLocation = () => {
    const storage = getSessionStorage();

    if (!storage) {
        return null;
    }

    const value = storage.getItem(returnLocationSessionStorageKey);
    return value || null;
};

export const hasReturnLocation = () => {
    return !!getReturnLocation();
};

export const setReturnLocation = (location: string | null | undefined) => {
    const storage = getSessionStorage();

    if (!storage) {
        return;
    }

    if (!location) {
        storage.removeItem(returnLocationSessionStorageKey);
        return;
    }

    storage.setItem(returnLocationSessionStorageKey, location);
};

export const clearReturnLocation = () => {
    setReturnLocation(null);
};

export const consumeReturnLocation = () => {
    const location = getReturnLocation();

    if (location) {
        clearReturnLocation();
    }

    return location;
};

export const navigateToReturnLocation = (
    navigate: NavigateFunction,
    fallback: () => void,
    options?: NavigateOptions
) => {
    const returnLocation = consumeReturnLocation();

    if (returnLocation) {
        navigate(returnLocation, options);
        return true;
    }

    fallback();
    return false;
};
